import { render } from "./Article.vue?vue&type=template&id=39eaead4&scoped=true&ts=true"
import script from "./Article.vue?vue&type=script&lang=ts"
export * from "./Article.vue?vue&type=script&lang=ts"

import "./Article.vue?vue&type=style&index=0&id=39eaead4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lq\\Desktop\\普康\\activity-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39eaead4"]])

export default __exports__